import { useState } from 'react';

const CopyToClipboardComponent = ({ textToCopy }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(textToCopy());
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // Reset "copied" state after 2 seconds
        } catch (err) {
            console.error('Failed to copy text: ', err);
            alert('Failed to copy text. Please try again.'); // Fallback alert for error
        }
    };

    return (
        <button onClick={handleCopy} className="btn btn-outline-primary waves-effect waves-light btnSize pl-2 ml-2"><i class="fa fa-copy pr-1 fs-2"></i> {copied ? 'Copied!' : 'Copy to Clipboard'}</button>

    );
};

export default CopyToClipboardComponent;